export function mapGetProductsToResponse(response: any): any {
  const { products, ...rest } = response;
  return {
    data: products,
    meta: rest,
  };
}

export function mapGetProductToResponse(response: any): any {
  return response.product;
}

export function mapGetCollectionToResponse(response: any): any {
  return response;
}
